// extracted by mini-css-extract-plugin
export default {"content":"TabContent_content__N8QLs"};